// @ts-nocheck

import React from 'react'
import styled from 'styled-components'
import Tumbler, { TumblerTypes } from './Tumbler'
import {LoadingLayer} from "../LoadingLayer";

type Block4Types = {
    className?: string,
    title?: string
    loading?: any
} & TumblerTypes

function Block4(props?: Block4Types) {


    return (
        <StyledBlock4 className={props.className}>
            {props.loading && <LoadingLayer/>}
            <div className='title'>{props.title}</div>
            <Tumbler className='tumbler' changeHandler={props.changeHandler} checked={props.checked} />
        </StyledBlock4>
    )
}


Block4.defaultProps = {
    title: 'Заголовок'


}


export default Block4


const StyledBlock4 = styled.div`
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  display: flex;
  width: 100%;
  height: 175px;
  border-radius: 15px;
  background-color: white;
  flex-direction: column;
  padding: 0 16px;
  align-items: center;
  font-family: "Open Sans";
  padding-top: 28px;
  box-sizing: border-box;
  position: relative;

  .title {
    font-size: 26px;
    font-weight: bold;

  }

  .tumbler {
    margin-top: 32px;
  }




`
